import type { FlowState } from "../../lib/flow-engine";
import { saveIntakeSession } from "./intakeSession";
import type {
  NateraIntakeAnswers,
  NateraIntakeConfig,
} from "./NateraIntakeFlow";
import {
  FEELINGS,
  type Feeling,
  STRESS_OPTIONS,
  type StressLevel,
} from "./persona";
import {
  BILL_SOURCES,
  type BillSourceData,
  type EmotionalData,
  type LandingEntry,
} from "./types";

export const validationEntrySession = (
  entry: BillSourceData & EmotionalData,
  landingEntry: LandingEntry,
  previous: NateraIntakeAnswers = {},
): { state: FlowState<NateraIntakeConfig>; answers: NateraIntakeAnswers } => ({
  state: { tag: "PersonaValidation", data: entry },
  answers: {
    ...previous,
    stressLevel: entry.stressLevel,
    feeling: entry.feeling,
    landingEntry,
  },
});

export const seedIntakeSessionFromRouting = async (answers: {
  stressLevel: StressLevel;
  feeling: Feeling;
}): Promise<void> => {
  const { state, answers: seeded } = validationEntrySession(
    { billSource: "natera", ...answers },
    "routing",
  );
  await saveIntakeSession(state, seeded);
};

/** `?bill=natera&stress=a-lot&feeling=worried`; null unless all three are valid. */
export const landingAnswersFromUrl = (
  search: string,
): (BillSourceData & EmotionalData) | null => {
  const params = new URLSearchParams(search);
  const billSource = BILL_SOURCES.find(s => s === params.get("bill"));
  const stressLevel = STRESS_OPTIONS.find(
    ({ id }) => id === params.get("stress"),
  )?.level;
  const feeling = FEELINGS.find(({ id }) => id === params.get("feeling"))?.id;
  return billSource && stressLevel && feeling
    ? { billSource, stressLevel, feeling }
    : null;
};
